import React, {FC} from 'react';
import '/site/parts/column-title/index.scss'

const ColumnTitle: FC = (props: any) => (
    <div className="column-title">{props.title}</div>
);

export default (props) => <ColumnTitle {...props} />;
